// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCyBGDncBIGkY0NWrmoHXofn9j6XVr385Q",
  authDomain: "setlist-f17c0.firebaseapp.com",
  projectId: "setlist-f17c0",
  storageBucket: "setlist-f17c0.firebasestorage.app",
  messagingSenderId: "736716111915",
  appId: "1:736716111915:web:144d182529f65cede8aa6e",
  measurementId: "G-TGYB3WSTFW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');

// Connect to the emulator in development
if (process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
